import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ToastContainerComponent } from '@ps-gui/shared-core';

@Component({
  selector: 'ct2-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, Toast, ToastContainerComponent],
})
export class AppComponent {}
